import {
  CreateNewAssessmentArgs,
  MissingConsentForm,
  SaveLaborEntryArgs,
  SubmitAssessmentCallInFormArgs,
  SubmitAssessmentResultsArgs,
  UpdateAssessmentAnswersArgs,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from './functions'

export const createNewAssessment = httpsCallable<CreateNewAssessmentArgs, string>(
  functions,
  'createNewAssessment',
)
export const submitAssessmentAnswers = httpsCallable(functions, 'submitAssessmentAnswers')

export const updateAssessmentAnswersFunction = httpsCallable<
  UpdateAssessmentAnswersArgs,
  { id: string; missingForms: MissingConsentForm[] }
>(functions, 'updateAssessmentAnswers')

export const submitAssessmentCallInForm = httpsCallable<SubmitAssessmentCallInFormArgs, string>(
  functions,
  'submitAssessmentCallInForm',
)

export const updateAssessmentViewed = httpsCallable(functions, 'updateAssessmentViewed')
export const submitAssessmentResults = httpsCallable<SubmitAssessmentResultsArgs>(
  functions,
  'submitAssessmentResults',
)
export const saveAssessmentDraft = httpsCallable(functions, 'saveAssessmentDraft')
export const moveAssessmentAuthorization = httpsCallable(functions, 'moveAssessmentAuthorization')
export const copyAssessmentLogs = httpsCallable(functions, 'copyAssessmentLogs')

export const fixFilesFunction = httpsCallable(functions, 'movePatientFilesToAssessment')
export const fixDoubleRenameFunction = httpsCallable(functions, 'fixDoubleResized')

export const sendOverduePaymentReminder = httpsCallable(functions, 'sendOverduePaymentReminder')
export const saveLaborEntryFunction = httpsCallable<
  SaveLaborEntryArgs,
  { success: string; id: string }
>(functions, 'saveLaborEntry')
